export enum LessonGroup {
  PRONUNCIATION = 'PRONUNCIATION',
  GRAMMAR = 'GRAMMAR',
  VOCABULARY = 'VOCABULARY',
  READING = 'READING',
  EXAM = 'EXAM',
}
